export const ACCOUNT_BAR_HEIGHT = 57;
